import { useSetRecoilState } from 'recoil';
import React from 'react';
import CachedIcon from '@mui/icons-material/Cached';
import { CustomButton } from 'shared/ui/CustomButton';
import { fileRenderKeyState } from 'features/file-browser/state/fileAtoms';


export const ReloadButton: React.FC = () => {
  const setRenderKey = useSetRecoilState(fileRenderKeyState);

  return (
    <CustomButton
      sx={{ fontSize: '10px', width: '100%' }}
      size="small"
      onClick={() => {
        setRenderKey((prevKey: number) => prevKey + 1);
      }}
      startIcon={<CachedIcon />}
    >
      Reload
    </CustomButton>
  );
};
